<template>
  <InsurancePlanFilter
    ref="filter"
    class="filter"
    :class="breakpointModifierClass"
    close-on-select
    inline
    @update:model-value="insuranceChanged"
  >
    <template #activator>
      <sp-button variant="outlined" class="activator" density="compact" no-wrap>
        <sp-icon slot="prepend" name="insurance-carrier-filled"></sp-icon>
        {{ title }}
        <sp-icon slot="append" name="popup-arrow-filled"></sp-icon>
      </sp-button>
    </template>
  </InsurancePlanFilter>
</template>

<script setup>
import { computed, ref } from "vue";
import { useBreakpoints } from "../../../composables/breakpoints";
import InsurancePlanFilter from "../../shared/components/InsurancePlanFilter.ce.vue";
defineProps({
  title: {
    type: String,
    default: "Check your insurance",
  },
});
const filter = ref(null);
const { isGtSmScreen } = useBreakpoints(filter);

const breakpointModifierClass = computed(() => ({
  "--bp-lt-sm": !isGtSmScreen.value,
}));

const emit = defineEmits(["update:model-value", "insurance-changed"]);

function insuranceChanged(value) {
  emit("insurance-changed", value);
}
</script>

<style scoped lang="scss">
.activator {
  --sp-comp-button-border-radius: 12px;
  --sp-comp-button-outlined-border-style: dashed;
  --sp-comp-button-outlined-border-color: var(--sp-comp-insurance-plan-filter-outlined-activator-border-color, inherit);
  --sp-comp-button-prepend-icon-size: 20px;
  --sp-comp-button-append-icon-size: 20px;
  --font-family: var(--sp-sys-font-family-medium);

  &:hover {
    --sp-comp-button-outlined-border-style: solid;
  }
}
.filter {
  &.--bp-lt-sm {
    --filter-width: 100%;
  }
}
</style>
